import React, { useState } from "react";
import close from "../../Pages/MyProfile/assets/close.png";
import { useBalance, useAccount } from "wagmi";
import ChainSelection from "../../Pages/MyProfile/ChainSelection/ChainSelection";

const formatDate = (date) => {
  if (date) {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return date.toLocaleDateString("en-US", options);
  }
  return "";
};
const LearnModal = ({ open, setOpen, thum, icon1, icon2, gold }) => {
  const [buttonText, setButtonText] = useState("ETH");
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [inputDays, setInputDays] = useState(1); // Assuming you have the inputDays state for the NumericInput
  const [selectedTime, setSelectedTime] = useState(new Date());
  const { address } = useAccount();
  const { data, isError, isLoading } = useBalance({
    address: address,
  });
  const minSelectableDate = new Date();
  minSelectableDate.setDate(minSelectableDate.getDate()); // Add 1 day to the current date

  const maxSelectableDate = new Date();
  maxSelectableDate.setDate(maxSelectableDate.getDate() + 89); // Add 30 days to the current date
  console.log(data);
  const handleTimeChange = (time) => {
    setSelectedTime(time);
  };
  const [value, onChange] = useState("10:00");
  const handleWrapClick = (e) => {
    e.stopPropagation();
    setOpen(false);
  };
  const handleETH = () => {
    if (buttonText === "ETH") {
      setButtonText("USDT");
    } else if (buttonText === "USDT") {
      setButtonText("ETH");
    }
  };
  const handleInputDaysChange = (value) => {
    setInputDays(value);
    const newDate = new Date();
    newDate.setDate(newDate.getDate() + value);
    setSelectedDate(newDate);
  };
  const handleDatePickerChange = (date) => {
    setSelectedDate(date);
    const currentDate = new Date();
    const differenceInDays = Math.ceil((date - currentDate) / (1000 * 60 * 60 * 24));
    setInputDays(differenceInDays);
  };

  return (
    <>
      <div
        onClick={handleWrapClick}
        className="fixed z-20   max-h-screen   overflow-y-scroll  removeScroll top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 flex justify-center items-start "
      >
        <div
          onClick={(e) => e.stopPropagation()}
          className="bg-main-black w-[350px] md:w-[481px] h-max  mt-[60px] md:mt-[100px] rounded-[20px]"
        >
          {/* header */}
          <div className="flex justify-between items-center pt-[31px] pl-[10px] md:pl-[36px] pr-[10px] md:pr-[24px] pb-[20px]">
            <h2 className="text-res-normal font-semibold ">Learn about Claim</h2>
            <button
              onClick={() => {
                setOpen(false);
              }}
              style={{
                boxShadow: "0px 0.909091px 1.81818px rgba(165, 163, 174, 0.3)",
              }}
              className="w-[20px] flex justify-center items-center h-[20px] bg-main-green rounded-[2px] "
            >
              <img src={close} alt="close" />
            </button>
          </div>
            <div className="mb-[20px] px-[10px] md:pl-[36px] md:pr-[31px]">
              <p>Are you a proud member of R34P DAO? This is your dedicated space to access and claim your vested tokens from the projects funded by the DAO. We believe in transparency and empowering our community members to enjoy the full benefits of their investments. Stay informed and take control of your token allocations through our user-friendly interface.</p>
            </div>
        </div>
      </div>
      <div onClick={() => setOpen(false)} className="fixed inset-0  z-10"></div>
    </>
  );
};

export default LearnModal;
